import { BehaviorSubject } from 'rxjs';
import { GameServices } from '../../game-services';
import { GameAssetType } from '../../game-types';
import { GameSizeMetrics } from 'src/games/common/phaser/game/scenes/scaled-base-scene';

export class StartViewModel {
  public get buttonAsset() {
    return this.gameServices.assetCatalogueService.getAsset(GameAssetType.StartButton);
  }
  public get layoutConfig() {
    return this.gameServices.gameMetricsService.gameLayoutConfig;
  }
  public get onShowStartButtonTrigger() {
    return this.showStartButtonTrigger.asObservable();
  }

  private readonly gameServices: GameServices;
  private readonly showStartButtonTrigger: BehaviorSubject<boolean>;

  constructor(gameServices: GameServices) {
    this.gameServices = gameServices;
    this.showStartButtonTrigger = new BehaviorSubject<boolean>(false);
  }

  public calculateScaleFactor(gameSizeMetrics: GameSizeMetrics): {
    totalWidth: number;
    scaleFactor: number;
  } {
    return this.gameServices.gameMetricsService.calculateBoardScaling(gameSizeMetrics);
  }

  public showStartButton(showButton: boolean) {
    this.showStartButtonTrigger.next(showButton);
  }

  public startClicked() {
    this.gameServices.gameRunnerService.startGame();
  }
}
